import { render } from "./IndexReservation.vue?vue&type=template&id=e6d16dac&scoped=true"
import script from "./IndexReservation.vue?vue&type=script&lang=js"
export * from "./IndexReservation.vue?vue&type=script&lang=js"

import "./IndexReservation.vue?vue&type=style&index=0&id=e6d16dac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6d16dac"]])

export default __exports__